// extracted by mini-css-extract-plugin
module.exports = {"modal":"DeleteApplicant-module_modal_sR6iG"};